// =============================================================
// AIRLINE CATALOG — minimal config per airline.
// Air France stays hand-crafted in ./airFrance.js (already
// validated by the user). Every other airline uses this catalog
// and is rendered via the contentGenerator.
// =============================================================

// Schema:
//   slug, name, country, hubs[], category, languages[],
//   heroImage (optional, falls back to default),
//   overrides (optional): per-lang hero / eyebrow / subtitle tweaks
//
// `languages[0]` is always 'en'. `languages[1]` (if any) is the
// secondary locale page.

export const AIRLINE_CATALOG = [
  // ---------------- LOW-COST / CHARTERS ----------------
  {
    slug: 'ryanair',
    name: 'Ryanair',
    country: 'Ireland',
    hubs: ['Dublin', 'London Stansted', 'Madrid'],
    category: 'lowcost',
    languages: ['en'],
  },
  {
    slug: 'easyjet',
    name: 'easyJet',
    country: 'the United Kingdom',
    hubs: ['London Gatwick', 'London Luton', 'Geneva', 'Paris CDG'],
    category: 'lowcost',
    languages: ['en'],
  },
  {
    slug: 'wizz-air',
    name: 'Wizz Air',
    country: 'Hungary',
    hubs: ['Budapest', 'Warsaw', 'Bucharest', 'Vienna'],
    category: 'lowcost',
    languages: ['en'],
  },
  {
    slug: 'vueling',
    name: 'Vueling',
    country: 'Spain',
    hubs: ['Barcelona', 'Paris Orly', 'Rome Fiumicino'],
    category: 'lowcost',
    languages: ['en'],
  },
  {
    slug: 'transavia',
    name: 'Transavia',
    country: 'France',
    hubs: ['Paris Orly', 'Lyon', 'Amsterdam'],
    category: 'lowcost',
    languages: ['en'],
  },
  {
    slug: 'eurowings',
    name: 'Eurowings',
    country: 'Germany',
    hubs: ['Düsseldorf', 'Cologne', 'Stuttgart', 'Hamburg'],
    category: 'lowcost',
    languages: ['en'],
  },
  {
    slug: 'volotea',
    name: 'Volotea',
    country: 'Spain',
    hubs: ['Asturias', 'Verona', 'Nantes'],
    category: 'lowcost',
    languages: ['en'],
  },
  {
    slug: 'norwegian',
    name: 'Norwegian',
    country: 'Norway',
    hubs: ['Oslo', 'Bergen', 'Copenhagen'],
    category: 'lowcost',
    languages: ['en'],
  },
  {
    slug: 'jet2',
    name: 'Jet2',
    country: 'the United Kingdom',
    hubs: ['Leeds Bradford', 'Manchester', 'Stansted'],
    category: 'lowcost',
    languages: ['en'],
  },
  {
    slug: 'pegasus',
    name: 'Pegasus',
    country: 'Türkiye',
    hubs: ['Istanbul Sabiha Gökçen', 'Ankara', 'Antalya'],
    category: 'lowcost',
    languages: ['en'],
  },
  {
    slug: 'sunexpress',
    name: 'SunExpress',
    country: 'Germany & Türkiye',
    hubs: ['Antalya', 'Frankfurt', 'Izmir'],
    category: 'lowcost',
    languages: ['en'],
  },

  // ---------------- LEGACY / NATIONAL CARRIERS ----------------
  {
    slug: 'lufthansa',
    name: 'Lufthansa',
    country: 'Germany',
    hubs: ['Frankfurt', 'Munich'],
    category: 'legacy',
    languages: ['en'],
  },
  {
    slug: 'klm',
    name: 'KLM',
    country: 'the Netherlands',
    hubs: ['Amsterdam Schiphol'],
    category: 'legacy',
    languages: ['en'],
  },
  {
    slug: 'british-airways',
    name: 'British Airways',
    country: 'the United Kingdom',
    hubs: ['London Heathrow', 'London Gatwick', 'London City'],
    category: 'legacy',
    languages: ['en'],
  },
  {
    slug: 'iberia',
    name: 'Iberia',
    country: 'Spain',
    hubs: ['Madrid Barajas'],
    category: 'legacy',
    languages: ['en'],
  },
  {
    slug: 'ita-airways',
    name: 'ITA Airways',
    country: 'Italy',
    hubs: ['Rome Fiumicino', 'Milan Linate'],
    category: 'legacy',
    languages: ['en'],
  },
  {
    slug: 'tap',
    name: 'TAP Air Portugal',
    country: 'Portugal',
    hubs: ['Lisbon', 'Porto'],
    category: 'legacy',
    languages: ['en'],
  },
  {
    slug: 'sas',
    name: 'SAS',
    country: 'Scandinavia',
    hubs: ['Copenhagen', 'Stockholm', 'Oslo'],
    category: 'legacy',
    languages: ['en'],
  },
  {
    slug: 'finnair',
    name: 'Finnair',
    country: 'Finland',
    hubs: ['Helsinki'],
    category: 'legacy',
    languages: ['en'],
  },
  {
    slug: 'austrian',
    name: 'Austrian',
    country: 'Austria',
    hubs: ['Vienna'],
    category: 'legacy',
    languages: ['en'],
  },
  {
    slug: 'swiss',
    name: 'Swiss',
    country: 'Switzerland',
    hubs: ['Zurich', 'Geneva'],
    category: 'legacy',
    languages: ['en'],
  },
  {
    slug: 'brussels-airlines',
    name: 'Brussels Airlines',
    country: 'Belgium',
    hubs: ['Brussels'],
    category: 'legacy',
    languages: ['en'],
  },
  {
    slug: 'lot',
    name: 'LOT Polish',
    country: 'Poland',
    hubs: ['Warsaw'],
    category: 'legacy',
    languages: ['en'],
  },
  {
    slug: 'aegean',
    name: 'Aegean',
    country: 'Greece',
    hubs: ['Athens', 'Thessaloniki'],
    category: 'legacy',
    languages: ['en'],
  },
  {
    slug: 'turkish-airlines',
    name: 'Turkish Airlines',
    country: 'Türkiye',
    hubs: ['Istanbul'],
    category: 'legacy',
    languages: ['en'],
  },
  {
    slug: 'aer-lingus',
    name: 'Aer Lingus',
    country: 'Ireland',
    hubs: ['Dublin', 'Cork'],
    category: 'legacy',
    languages: ['en'],
  },
];
